import { render, staticRenderFns } from "./matchWaiting.vue?vue&type=template&id=3911ace8&scoped=true"
import script from "./matchWaiting.vue?vue&type=script&lang=js"
export * from "./matchWaiting.vue?vue&type=script&lang=js"
import style0 from "./matchWaiting.vue?vue&type=style&index=0&id=3911ace8&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3911ace8",
  null
  
)

export default component.exports